import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import './successPage.css';

const SuccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  
    if (window.fbq) {
      window.fbq("init", "1681003322662937");
      window.fbq("track", "PageView");
      window.fbq("track", "Lead");
    }
  }, []);
  
  

  return (
    <div className="wrapper1">
      <Helmet>
        <title>Success - Piercing Service UAE</title>
        <meta id="meta-description" name="description" content="Your submission was successful." />
        <meta id="og-title" property="og:title" content="Piercing Service UAE - Success" />
        <meta id="og-image" property="og:image" content="path/to/image.jpg" />
      </Helmet>
      <noscript>
        <img height="1" width="1" style={{ display: "none" }}
          src="https://www.facebook.com/tr?id=1681003322662937&ev=PageView&noscript=1"
        />
      </noscript>
      <div className="content1">
        <h1>Submitted Successfully</h1>
        <p>We will get back to you soon.</p>
        <button onClick={() => navigate("/")}>Back to Home</button>
      </div>
    </div>
  );
};

export default SuccessPage;
